import { FunctionComponent } from 'react';
import { EllipsisText } from 'components/tables/EllipsisText';
import { StyledCell } from 'components/tables/cells/styles';
import { CellProps } from 'components/tables/cells';
import {
	getProductAccessStatusName,
	ProductAccessStatus,
} from 'domain/product/enums';

export interface ProductAccessStatusCellProps extends CellProps {
	status: ProductAccessStatus;
}

const ProductAccessStatusCell: FunctionComponent<
	ProductAccessStatusCellProps
> = ({ align = 'flex-start', justify = 'center', offsetLeft, status }) => {
	let cellColor;
	switch (status) {
		case ProductAccessStatus.Allowed:
			cellColor = 'bgSuccess';
			break;
		case ProductAccessStatus.Denied:
			cellColor = 'bgError';
			break;
		default:
			cellColor = 'textSubtle';
			break;
	}

	return (
		<StyledCell align={align} justify={justify} $offsetLeft={offsetLeft}>
			<EllipsisText as={'span'} size="sm" color={cellColor}>
				{getProductAccessStatusName(status)}
			</EllipsisText>
		</StyledCell>
	);
};

export default ProductAccessStatusCell;
